import { useTranslations } from 'next-intl';

import type { PromptModalProps } from '@/types/modal';

import { Button } from '../ui/button';
import BaseModal from './BaseModal';

function PromptModal(props: PromptModalProps) {
  const translate = useTranslations();

  const {
    title,
    promptText,
    open,
    children,
    onOpenChange,
    isCritical = false,
    description,
    className,
    footer,
  } = props;

  const buttonText = promptText ?? translate('modal.continue');

  return (
    <BaseModal
      onOpenChange={onOpenChange}
      open={open}
      title={title}
      description={description}
      className={className}
      footer={(
        footer
        || (
          <div className="mt-5 flex items-center justify-end gap-2">
            <Button
              color="error"
              variant={isCritical ? 'outline' : 'primary'}
              onClick={() => {
                onOpenChange(false);
              }}
            >
              {buttonText}
            </Button>
          </div>
        )
      )}
    >
      {children}
    </BaseModal>
  );
}

export default PromptModal;
